'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var STARTED = exports.STARTED = 'STARTED';
var SUCCEEDED = exports.SUCCEEDED = 'SUCCEEDED';
var FAILED = exports.FAILED = 'FAILED';
var UNINITIALIZED = exports.UNINITIALIZED = 'UNINITIALIZED';